const ONE_YEAR_SECONDS = 31_536_000;

export function publicImmutableUploadMetadata(file: File) {
    return {
        contentType: file.type || 'application/octet-stream',
        cacheControl: `public,max-age=${ONE_YEAR_SECONDS},immutable`,
    };
}

export function privateImmutableUploadMetadata(file: File) {
    return {
        contentType: file.type || 'application/octet-stream',
        cacheControl: `private,max-age=${ONE_YEAR_SECONDS},immutable`,
    };
}
